import { getMerchantToken } from "./merchantAuthApi";
const BASE = (process.env.REACT_APP_MERCHANT_API_BASE_URL || "http://secondbite-manage.localhost/merchant-api/v1").replace(/\/+$/, "");
const qs = (filters) => new URLSearchParams(filters).toString();
export const getOrderPerformance = async (filters) => {
  const response = await fetch(`${BASE}/reports/order-performance?${qs(filters)}`, { headers: { Accept: "application/json", Authorization: `Bearer ${getMerchantToken()}` } });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load order performance.");
  return payload.data;
};
export const exportOrderPerformance = async (filters) => {
  const response = await fetch(`${BASE}/reports/order-performance/export?${qs(filters)}`, { headers: { Accept: "text/csv", Authorization: `Bearer ${getMerchantToken()}` } });
  if (!response.ok) throw new Error("Unable to export order performance.");
  return response.blob();
};
